/**
 * Default catalog seed values — must match migration seeds and historical hardcoded lists.
 * Used as offline/failure fallback so consumer behavior stays identical.
 * Not a live platform catalog — never substitute for a successful empty org query.
 */

export const DEFAULT_CLASSIFICATIONS = Object.freeze([
  { name: "Helper", display_order: 1 },
  { name: "Apprentice 1", display_order: 2 },
  { name: "Apprentice 2", display_order: 3 },
  { name: "Apprentice 3", display_order: 4 },
  { name: "Journeyman", display_order: 5 },
  { name: "Lead Hand", display_order: 6 },
  { name: "Foreman", display_order: 7 },
  { name: "Project Manager", display_order: 8 },
  { name: "Operations Manager", display_order: 9 },
]);

export const DEFAULT_PAYROLL_TYPES = Object.freeze([
  {
    type_key: "Standard",
    display_label: "User Rate",
    display_order: 1,
    is_system: false,
  },
  {
    type_key: "Residential",
    display_label: "Residential (CCQ)",
    display_order: 2,
    is_system: false,
  },
  {
    type_key: "Commercial",
    display_label: "Commercial",
    display_order: 3,
    is_system: false,
  },
  {
    type_key: "Industrial",
    display_label: "Industrial",
    display_order: 4,
    is_system: false,
  },
  {
    type_key: "Custom",
    display_label: "Residential (Non-CCQ)",
    display_order: 5,
    is_system: true,
  },
]);

/**
 * Historical Review / Finalize Category list.
 * Seeded for every organization until an owner/admin customizes Work Types.
 */
export const DEFAULT_WORK_TYPES = Object.freeze([
  { name: "Installation", display_order: 1 },
  { name: "Service", display_order: 2 },
  { name: "Maintenance", display_order: 3 },
  { name: "Administration", display_order: 4 },
]);

/** Engine keys — immutable type_key; application logic always uses these values. */
export const RESERVED_PAYROLL_TYPE_KEYS = new Set([
  "Standard",
  "Residential",
  "Custom",
  "Commercial",
  "Industrial",
]);

/** Rows that cannot be deactivated (legacy seed flag; Custom). */
export const SYSTEM_PAYROLL_TYPE_KEYS = new Set(["Custom"]);
